// Import Packages
import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';

// Import Material UI
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";

// Import CSS
import "./ModuleItem.css";

// The fromItem parameter has been added for the + icon.
const ModuleItem = ({
    icon,
    title,
    description,
    learnMoreLink,
    count,
    children,
    fromItem,
    isEhFlow
}) => {
    const { t } = useTranslation();
    const [expand, setExpand] = useState(false);

    useEffect(() => {
        setExpand(false)
    }, [isEhFlow])

    return (
        <div className="module-item-container font-manrope" style={fromItem && { height: '100%', marginBottom: '0' }}>
            <div className="module-item-padding">
                <div className="ml-item-header module-item-header">
                    <div className="module-item-title-container">
                        <img
                            loading="lazy"
                            src={icon}
                            className={fromItem && "library-img"}
                            alt=""
                            draggable={false}
                        />
                        <span className="module-item-title">{title}</span>
                        {
                            count >= 0 &&
                            <div className="module-item-count-container">
                                <span className="module-item-count">{count}</span>
                            </div>
                        }
                    </div>
                    {!fromItem && (expand ? <RemoveIcon className="module-item-expand" onClick={() => setExpand(false)} /> : <AddIcon className="module-item-expand" onClick={() => setExpand(true)} />)}
                </div>
                {
                    description &&
                    <div className="module-item-description">
                        {description}
                    </div>
                }
                {
                    learnMoreLink &&
                    <div className="module-item-more">
                        <a href={learnMoreLink} target="_blank">{t("CONTENT.FLOW.LEFT-AREA.LEARN-MORE")}</a>
                    </div>
                }
                {
                    expand &&
                    <>
                        <div className="module-item-divider" />

                        <div className="module-item-content">
                            {children}
                        </div>
                    </>
                }
            </div>
        </div>
    )
}

export default ModuleItem;
